import React, { useState, useEffect } from 'react';
import { ButtonToolbar } from 'shards-react';
import EditConditionOrdinary from './EditConditionOrdinary';
import EditConditionCustomize from './EditConditionCustomize';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { showErrorMessage, setDialogMode, openDialog, updateConditionCustomize } from '../../../redux/slices/condition';
import isConditionCustomizeUpdated from '../../../utils/manage-condition/isConditionCustomizeUpdated';
import { CONDITION_STATUS, CONDITION_VIEW_MODES, MANAGE_CONDITION_TYPES } from '../../../constants';
import type { CreateConditionDetailParams, UpdateConditionWithDetailParams } from '../../../types/condition';

const EditConditionDetail = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { selectedTab, selectedViewMode, condition, conditionOrg } = useSelector((state: RootState) => state.condition);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isNotSaved, setIsNotSaved] = useState<boolean>(false);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 編集可能な状態かをチェックする
  useEffect(() => {
    if (selectedViewMode === CONDITION_VIEW_MODES.EDITING && (condition?.conditionStatus === CONDITION_STATUS.APPROVED || condition?.conditionStatus === CONDITION_STATUS.EDITING)) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [selectedViewMode, condition?.conditionStatus]);

  // 詳細可視制御に変更があるかをチェックする
  useEffect(() => {
    // console.log(condition !== undefined, conditionOrg !== undefined, isConditionCustomizeUpdated(condition?.detailCustomize, conditionOrg?.detailCustomize));
    if (condition !== undefined && conditionOrg !== undefined && isConditionCustomizeUpdated(condition.detailCustomize, conditionOrg.detailCustomize)) {
      setIsNotSaved(true);
    } else {
      setIsNotSaved(false);
    }
  }, [condition?.detailCustomize]);

  // EVENT HANDLER
  // ================================================================================

  const handleAddCondition = (): void => {
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // 通常可視制御と異なり、値がない項目も空文字列にしてリクエストに含める。
  // ただしコピー元のConditionOptionはすでに適切な形（余計な項目は持っておらず、必要項目は値がなくても空文字列になっている）
  // になっているのでそのままパラメータに設定すればよい
  const handleSaveCondition = (): void => {
    if (condition !== undefined) {
      const detailCustomize: CreateConditionDetailParams[] = condition.detailCustomize.map((detail) => {
        return {
          conditionId: detail.conditionId,
          isApproved: false,
          conditionType: MANAGE_CONDITION_TYPES.CUSTOMIZE,
          customer: undefined,
          customer1: detail.customer1,
          customer2: detail.customer2,
          customer3: detail.customer3,
          deliveryLocation: detail.deliveryLocation,
          standard: detail.standard,
          sizeDisplay: detail.sizeDisplay,
        };
      });
      const params: UpdateConditionWithDetailParams = {
        detailCustomize,
        conditionStatus: CONDITION_STATUS.EDITING,
      };
      dispatch(updateConditionCustomize(params));
    } else {
      dispatch(showErrorMessage('対象の可視制御が選択されていません'));
    }
  };

  // VIEW
  // ================================================================================

  if (selectedViewMode !== CONDITION_VIEW_MODES.EDITING) {
    return <></>;
  }

  return (
    <>
      <ButtonToolbar>
        {selectedTab === MANAGE_CONDITION_TYPES.ORDINARY && <EditConditionOrdinary editable={isEditable} onClick={handleAddCondition} />}
        {selectedTab === MANAGE_CONDITION_TYPES.CUSTOMIZE && <EditConditionCustomize editable={isEditable} saved={!isNotSaved} onClick={handleSaveCondition} />}
      </ButtonToolbar>
    </>
  );
};

export default EditConditionDetail;
